import {
  ArrowLeftOutlined,
  EnvironmentOutlined,
  StarFilled,
  StarOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Avatar } from "antd";
import { List, Popup } from "antd-mobile";
import style from "css/hotdesking.module.css";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

function SearchTeam({
  isOpen,
  onClose,
  list,
  onShowBook,
  onAddFavorite,
  onCancelFavorite,
}) {
  const { t } = useTranslation();
  const [departmentName, setDepartmentName] = useState("");
  useEffect(() => {
    if (isOpen) {
      const department = list[0]?.department?.name;
      setDepartmentName(department);
    }
  }, [isOpen, list]);
  return (
    <Popup
      className={`${style.popup} ${style.user}`}
      visible={isOpen}
      onMaskClick={onClose}
    >
      <section className={style.popup_wrapper}>
        <section className={style.popup_container}>
          <section className={style.popup_header}>
            <ArrowLeftOutlined
              className={style.header_icon}
              onClick={onClose}
            />
            <p>{t("HOTDESKING.MENU.TEAM.BUTTON.MY_TEAM")}</p>
          </section>
          <section className={style.popup_content}>
            <section className={style.popup_content_list}>
              {list.length > 0 && (
                <List
                  className={style.popup_list}
                  header={
                    <section className={style.popup_list_header}>
                      <p className={style.header_title}>{departmentName}</p>
                      <div className={style.header_count}>
                        <p>{list.length}</p>
                      </div>
                    </section>
                  }
                >
                  {list.map((item, idx) => (
                    <List.Item
                      className={style.popup_list_item_wrap}
                      key={idx}
                      onClick={() => {
                        if (item.resource !== undefined) {
                          onShowBook(
                            {
                              ...item,
                              member: {
                                department: item.department,
                                id: item.id,
                                name: item.name,
                                role: item.role,
                              },
                            },
                            item.resource
                          );
                        }
                      }}
                      arrowIcon={false}
                    >
                      <section className={style.popup_list_item}>
                        <section className={style.user_info_section}>
                          <Avatar
                            className={style.user_avatar}
                            icon={
                              <UserOutlined
                                className={style.user_avatar_icon}
                              />
                            }
                          />
                          <article className={style.user_info_article}>
                            <p className={style.user_name}>{item.name}</p>
                            <div className={style.user_department}>
                              <p>{item.role}</p>
                              <span className={style.driver} />
                              <p>{item.department.name}</p>
                            </div>
                            <div
                              className={
                                item.resource === undefined
                                  ? style.user_location
                                  : `${style.user_location} ${style.inuse}`
                              }
                            >
                              <EnvironmentOutlined
                                className={style.location_icon}
                              />
                              {item.resource === undefined ? (
                                <p className={style.location_title}>
                                  No Workplace
                                </p>
                              ) : (
                                <>
                                  <p className={style.location_title}>
                                    {item.resource.location.title}
                                  </p>
                                  <p className={style.location_title}>
                                    {item.resource.title}
                                  </p>
                                </>
                              )}
                            </div>
                          </article>
                        </section>

                        {item.favorite ? (
                          <StarFilled
                            className={`${style.favorite_icon} ${style.fill}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              onCancelFavorite(item.id);
                            }}
                          />
                        ) : (
                          <StarOutlined
                            className={style.favorite_icon}
                            onClick={(e) => {
                              e.stopPropagation();
                              onAddFavorite(item.id);
                            }}
                          />
                        )}
                      </section>
                    </List.Item>
                  ))}
                </List>
              )}
            </section>
          </section>
        </section>
      </section>
    </Popup>
  );
}

export default SearchTeam;
